import React from 'react';
import { Gift, Clock, Heart, Moon } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Bonuses() {
  return <div className="bg-cream-dark border-y border-beige-muted/50" data-id="element-41">
      <Section data-id="element-42">
        <SectionTitle data-id="element-43">Esto es lo que hace que funcione de verdad</SectionTitle>

        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-44">
          <div className="inline-flex items-center justify-center bg-gold/20 text-charcoal font-bold px-4 py-2 rounded-full mb-6 gap-2" data-id="element-45">
            <Gift className="w-5 h-5 text-gold-hover" data-id="element-46" />
            <span data-id="element-47">Hoy además te llevás esto</span>
          </div>
          <p className="text-lg text-charcoal-light" data-id="element-48">
            Si empezás hoy, además del método, vas a recibir{' '}
            <strong data-id="element-49">3 bonos especiales</strong> para acelerar los resultados.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-50">
          {/* Bonus 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-51">
            <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-52"></div>
            <div className="bg-sage-light/30 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-53">
              <Clock className="w-7 h-7 text-sage-dark" data-id="element-54" />
            </div>
            <h3 className="font-bold text-charcoal text-xl mb-2" data-id="element-55">
              BONO 1: RUTINAS PODEROSAS
            </h3>
            <p className="text-charcoal-light mb-4" data-id="element-56">
              Guía práctica para crear rutinas simples y efectivas
            </p>
            <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-57">
              Incluido GRATIS hoy
            </span>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-58">
            <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-59"></div>
            <div className="bg-gold-light/50 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-60">
              <Heart className="w-7 h-7 text-gold-hover" data-id="element-61" />
            </div>
            <h3 className="font-bold text-charcoal text-xl mb-2" data-id="element-62">
              BONO 2: MASAJE SHANTALA
            </h3>
            <p className="text-charcoal-light mb-4" data-id="element-63">
              Técnica de masaje para relajar y mejorar el sueño
            </p>
            <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-64">
              Incluido GRATIS hoy
            </span>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-65">
            <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-66"></div>
            <div className="bg-sage-light/30 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-67">
              <Moon className="w-7 h-7 text-sage-dark" data-id="element-68" />
            </div>
            <h3 className="font-bold text-charcoal text-xl mb-2" data-id="element-69">
              BONO 3: REGRESIONES DEL SUEÑO
            </h3>
            <p className="text-charcoal-light mb-4" data-id="element-70">
              Cómo actuar cuando tu bebé vuelve a despertarse
            </p>
            <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-71">
              Incluido GRATIS hoy
            </span>
          </div>
        </div>
      </Section>
    </div>;
}